import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";
import { useDnDBypassContext } from "@/components/builder/utils/bypass-context";

import BasePreview from "../../../base";

function FormRadioLabelPreview({ ...props }) {
  const { data: { value } } = useDnDBypassContext()

  return <BasePreview {...props}>
    <span>
      {value?.label}
    </span>
  </BasePreview>
}

export default define('form-radio-label', FormRadioLabelPreview, Fragment)
  .shared(prop.share('FormRadioLabel', 'form-radio-label'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultProps({
    fontSize: 'sm',
  })
  .build()

